<!-- Spacer -->
<div class="zop-horizontal-navigation-item-wrapper" [ngClass]="item.classes?.wrapper"></div>